import { RetailerFragment } from '@lib/umbraco/generated/types.generated'
import cn from 'clsx'
import { deepEqual } from 'fast-equals'
import { FC } from 'react'
import styles from './RetailerCard.module.scss'

type RetailerCardProps = {
  retailer: RetailerFragment
  onRetailerClick?: (retailer: RetailerFragment) => void
  directionsText: string
  selectedRetailer: RetailerFragment | undefined
}

const RetailerCard: FC<RetailerCardProps> = ({
  retailer,
  onRetailerClick,
  directionsText,
  selectedRetailer,
}) => {
  const phoneRawHtml = {
    __dangerousHTML: retailer.phone,
  }

  return onRetailerClick ? (
    <li
      id={retailer.odooUUID}
      className={cn(
        styles.container,
        deepEqual(retailer, selectedRetailer) && styles.active,
        'bodyText',
      )}
      onClick={() => onRetailerClick(retailer)}
    >
      <article className={styles.card}>
        <h3 className={styles.title}>{retailer.name}</h3>
        {retailer.filterTags && (
          <div className={styles.tags}>
            {retailer.filterTags.map((tag, index) => (
              <span key={index} className={styles.tag}>
                {tag}
              </span>
            ))}
          </div>
        )}
        <div className={styles.address}>
          <span>{`${retailer.street} ${retailer.street2}`}</span>
          <span>{`${retailer.city} ${retailer.zip}`}</span>
          <span>{retailer.country}</span>
        </div>

        {/* <RawHTML>
          {phoneRawHtml}
        </RawHTML> */}
        <span dangerouslySetInnerHTML={{ __html: retailer.phone }} />

        <a
          className={styles.website}
          href={retailer.websiteLink}
          target="_blank"
          rel="noreferrer"
        >
          {
            retailer.websiteLink
              .replace('https://', '')
              .replace('http://', '')
              .split('/')[0]
          }
        </a>
        <a
          className={`${styles.website} pt-4`}
          target="_blank"
          rel="noreferrer"
          href={`https://www.google.com/maps/dir/?api=1&destination=${retailer.geoLatitude},${retailer.geoLongitude}`}
        >
          {directionsText}
        </a>
      </article>
    </li>
  ) : (
    <></>
  )
}

export default RetailerCard
